export const careListingBreadcrumbs = {
  care: "Care",
  products: "Products",
};
